import { createContext } from 'react';

import { GlobalProps } from '@interfaces';

const GlobalData = createContext<GlobalProps>(undefined!);

export default GlobalData;
